import React, { memo, useState, useCallback } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { areEqual } from 'Utils/equalityChecks';
import { Spinner } from 'Components/Spinner';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

interface Props {
  pdfUrl: string;
  scale: number;
  currentPage: number;
  onDocumentLoadSuccess: (data: { numPages: number }) => void;
  onPageLoadSuccess: (page: any) => void;
  children?: React.ReactNode;
}

function PdfViewer({ pdfUrl, scale, currentPage, onDocumentLoadSuccess, onPageLoadSuccess, children }: Props) {
  const [loading, setLoading] = useState(true);

  const handleDocLoad = useCallback(
    (data: { numPages: number }) => {
      setLoading(false);
      onDocumentLoadSuccess(data);
    },
    [onDocumentLoadSuccess]
  );

  return (
    <Document file={pdfUrl} onLoadSuccess={handleDocLoad} loading={<div style={{ padding: 40, textAlign: 'center' }}><Spinner loading /></div>}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <Page
          pageNumber={currentPage}
          scale={scale}
          onLoadSuccess={onPageLoadSuccess}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
        {!loading && children}
      </div>
    </Document>
  );
}

const PdfViewerMemo = memo(PdfViewer, areEqual);
export { PdfViewerMemo as PdfViewer };
